import React from 'react'

interface Props {
  onClose: () => void
  onCloseClicked: () => void
  title: string
  subtitle?: string
  children: Readonly<React.ReactNode>
  header?: Readonly<React.ReactNode>
  isTransparent: boolean
  isBig?: boolean
  hasCloseIcon?: boolean
}

export default function AppModal({ onClose, title, children, isTransparent, onCloseClicked, subtitle, header, isBig, hasCloseIcon = true }: Props) {

  return (
    <div
      className={["overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full md:inset-0 h-full max-h-full bg-black-base bg-opacity-40 transition-all duration-700",
        isTransparent ? "opacity-0" : "opacity-100"
      ].join(" ")}

      onTransitionEnd={() => {
        if (isTransparent) {
          onClose();
        }

      }}
    >
      <div className={["relative p-4 w-full max-h-full", isBig ? "max-w-6xl" : "max-w-2xl"].join(" ")}>
        <div className="relative bg-white rounded-lg shadow sliding-down">
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
            {header ? header : <h3 className="text-lg font-medium md:text-xl md:font-semibold text-black-base">
              {title}
              {subtitle ? <span className='text-base font-normal'>
                {subtitle}
              </span> : null}
            </h3>}
            {hasCloseIcon ? <button onClick={onCloseClicked} type="button" className="bg-transparent text-black-base text-sm w-8 h-8 ms-auto inline-flex justify-center items-center">
              <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
              </svg>
              <span className="sr-only">Close modal</span>
            </button> : null}
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
